import { gql } from '@apollo/client';

export const GET_PRE_RELEASE_ASSET = gql`
  query GetPreReleaseAsset($hex: String!) {
    preReleaseAsset(hex: $hex) {
      id
      name
      vin
      soldSaleAsset {
        id
        lotNumber
        titleOwnerName
        titleShippingAddress1
        titleShippingAddress2
        titleCity
        titleState
        titleZip
      }
    }
  }
`;

export const UPDATE_SALE_ASSET_PRE_RELEASE = gql`
  mutation UpdateSaleAssetPreRelease(
    $hex: String!
    $titleOwnerName: String!
    $titleShippingAddress1: String!
    $titleShippingAddress2: String
    $titleCity: String!
    $titleState: String!
    $titleZip: String!
  ) {
    updateSaleAssetPreRelease(
      hex: $hex
      titleOwnerName: $titleOwnerName
      titleShippingAddress1: $titleShippingAddress1
      titleShippingAddress2: $titleShippingAddress2
      titleCity: $titleCity
      titleState: $titleState
      titleZip: $titleZip
    ) {
      saleAsset {
        id
        titleOwnerName
        titleShippingAddress1
        titleShippingAddress2
        titleCity
        titleState
        titleZip
      }
      errors {
        path
        message
      }
    }
  }
`;
